import{useRecoveryPhraseProtected}from"./useRecoveryPhraseProtected";export default useRecoveryPhraseProtected;